import { createFileRoute } from '@tanstack/react-router';

import { validatePortSearch } from '@/features/operator/list-search';
import { VehiclesPage } from '@/features/operator/vehicles-page';

export const Route = createFileRoute('/_operator/vehicles')({
	validateSearch: validatePortSearch,
	component: VehiclesPage,
});
